import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorRelatedConditionsRefineButton = props => {
  const {
    dataSeleniumInfo,
    onClick,
    disabled
  } = props;
  return /*#__PURE__*/_jsx(UIButton, {
    className: "m-left-0 m-top-2",
    "data-selenium-info": dataSeleniumInfo,
    "data-selenium-test": "fr-refine-btn",
    disabled: disabled,
    onClick: onClick,
    size: "xs",
    use: "tertiary-light",
    responsive: false,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.refineButton"
    })
  });
};
export default EditorRelatedConditionsRefineButton;